export const buyerFields = [
  {
    label: "First Name",
    name: "firstName",
    type: "text",
    placeholder: "First Name",
    required: true,
    defaultValue: "",
    pattern: "^[a-zA-Z0-9\-._' ]*$", // Only letters and spaces
    maxLength: 40,
  },
  {
    label: "Last Name",
    name: "lastName",
    type: "text",
    placeholder: "Last Name",
    required: true,
    defaultValue: "",
    pattern: "^[a-zA-Z0-9\-._' ]*$", // Only letters and spaces
    maxLength: 40,
  },

  {
    label: "Middle Name",
    name: "middleInitials",
    type: "text",
    placeholder: "Middle Name",
    required: false,
    defaultValue: "",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    maxLength: 10,
  },
  {
    label: "Individual Address",
    name: "address1",
    type: "text",
    placeholder: "Individual Address", // Changed for individual
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
  {
    label: "State",
    name: "stateId",
    type: "select",
    placeholder: "State",
    required: true,
    defaultValue: "",
  },
  {
    label: "City",
    name: "city",
    type: "text",
    placeholder: "City",
    required: true,
    defaultValue: "",
    suggestions: true,
  },
  {
    label: "Zip",
    name: "zip",
    type: "text",
    placeholder: "Zip",
    required: true,
    defaultValue: "",
    pattern: "^[0-9]{5}(?:-[0-9]{4})?$",
    maxLength: 5,
  },
  {
    label: "Email",
    name: "email",
    type: "email",
    placeholder: "Email",
    required: true,
    defaultValue: "",
    pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
  },
  {
    label: "Phone Number",
    name: "phone",
    type: "text",
    placeholder: "Phone Number",
    required: true,
    defaultValue: "",
    maxLength: 10,
    pattern: "^\\d{10}$",
  },

  // {
  //   label: "Address Line 2",
  //   name: "address2",
  //   type: "text",
  //   placeholder: "Address Line 2",
  //   required: false,
  //   defaultValue: "",
  //   maxLength: 100,
  // },
];

export const businessFields = [
  // First name, Last name, Middle name
  ...buyerFields.slice(0, 3),
  {
    label: "Company Name",
    name: "companyName",
    type: "text",
    placeholder: "Corporation Name",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
  // Address with different placeholder
  {
    ...buyerFields[3],
    placeholder: "Corporation Address", // Changed for business
    label: "Corporation Address",
  },
  // Rest of the fields (State, City, Zip, Email, Phone)
  ...buyerFields.slice(4),
];

export const buyerAgent = [
  ...buyerFields,
  {
    label: "Agency Name",
    name: "agencyName",
    type: "text",
    placeholder: "Agency Name",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },

  {
    label: "Inidividual License State",
    name: "individualLicenseState",
    type: "select",
    placeholder: "Inidividual License State",
    required: true,
    defaultValue: "",
  },
  {
    label: "Individual License Number",
    name: "individualLicenseNumber",
    type: "text",
    placeholder: "Individual License Number",
    required: true,
    defaultValue: "",
  },
  {
    label: "Individual License Expiry Date",
    name: "licenseExpiryDate",
    type: "text",
    placeholder: "Individual License Expiry Date(MM/DD/YYYY)",
    required: true,
    defaultValue: "",
    pattern: "^(0[1-9]|1[0-2])/(0[1-9]|[12]\\d|3[01])/\\d{4}$",
    maxLength: 10,
  },
  {
    label: "Select corporation state",
    name: "corporateLicenseState",
    type: "select",
    placeholder: "corporation  state",
    required: false,
    defaultValue: "",
  },
  {
    label: "Corporation License Number",
    name: "corporateLicenseNumber",
    type: "text",
    placeholder: "Corporation License Number",
    required: false,
    defaultValue: "",
  },
];
// Common fields remain the same (buyerFields)

// Non-CWCOT Entity Fields
export const selfOccupancyFields = [
  ...buyerFields,
  // No additional input field, only document upload
];

export const hudNonProfitFields = [
  ...buyerFields,
  {
    label: "Organization Name",
    name: "organizationName",
    type: "text",
    placeholder: "Name of the Non profit Entity",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
];

export const governmentEntityFields = [
  ...buyerFields,
  {
    label: "Government Entity Name",
    name: "governmentEntityName",
    type: "text",
    placeholder: "Name of the Governmental Entity",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
];

// CWCOT Entity Fields
export const ownerOccupiedFields = [
  ...buyerFields,
  // No additional input field, only document upload
];

export const nonProfitCorpFields = [
  ...buyerFields,
  {
    label: "Non-Profit Corporation Name",
    name: "nonProfitCorpName",
    type: "text",
    placeholder: "Name of the non-profit corporation",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
];

export const landTrustFields = [
  ...buyerFields,
  {
    label: "Land Trust Name",
    name: "landTrustName",
    type: "text",
    placeholder: "Name of the community land trust ",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
];

export const housingCoopFields = [
  ...buyerFields,
  {
    label: "Housing Co-operative Name",
    name: "housingCoopName",
    type: "text",
    placeholder: "Name of the Limited Equity housing co-operative",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
];

export const californiaStateFields = [
  ...buyerFields,
  // No additional input field, only document upload
];

export const cwcotHudNonProfitFields = [
  ...buyerFields,
  {
    label: "Organization Name",
    name: "organizationName",
    type: "text",
    placeholder: "Name of the Non-profit Entity",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
];

export const cwcotGovernmentFields = [
  ...buyerFields,
  {
    label: "Government Entity Name",
    name: "governmentEntityName",
    type: "text",
    placeholder: "Name of the government entity ",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
];
// CA Bill Entity Fields
export const caBillOwnerOccupiedFields = [
  ...buyerFields,
  // No additional input field, only document upload
];

export const caBillNonProfitFields = [
  {
    label: "Non-Profit Corporation Name",
    name: "caBillNonProfitName",
    type: "text",
    placeholder: "Name of the non-profit corporation",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
  ...buyerFields,
];

export const caBillLandTrustFields = [
  {
    label: "Community Land Trust Name",
    name: "caBillLandTrustName",
    type: "text",
    placeholder: "Name of the community land trust ",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
  ...buyerFields,
];

export const caBillHousingCoopFields = [
  {
    label: "Limited Equity Housing Co-operative Name",
    name: "caBillHousingCoopName",
    type: "text",
    placeholder: "Name of the limited equity housing co-operative ",
    pattern: "^[a-zA-Z0-9\-._' ]*$",
    required: true,
    defaultValue: "",

    maxLength: 40,
  },
  ...buyerFields,
];

export const caBillCaliforniaStateFields = [
  ...buyerFields,
  // No additional input field, only document upload
];

// First Look (SPS 945) Entity Fields
// Both First Look options use the same fields as a standard Individual buyer.
// Only the buyerCategory in the save payload differs between the two options.
export const firstLookOwnerOccupiedFields = [...buyerFields];

export const firstLookNonProfitFields = [...buyerFields];

export const agentAndtitleInsuranceProvider = [
  {
    label: "First Name",
    name: "firstName",
    type: "text",
    placeholder: "First Name",
    required: true,
    defaultValue: "",
    pattern: "^[a-zA-Z0-9\-._' ]*$", // Only letters and spaces
    maxLength: 40,
  },
  {
    label: "Email",
    name: "email",
    type: "email",
    placeholder: "Email",
    required: true,
    defaultValue: "",
    pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
  },

  {
    label: "Company Name",
    name: "companyName",
    type: "text",
    placeholder: "Corporation Name",
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
  {
    label: "Phone Number",
    name: "phone",
    type: "text",
    placeholder: "Phone Number",
    required: true,
    defaultValue: "",
    maxLength: 10,
    pattern: "^\\d{10}$",
  },

  {
    label: "Address2",
    name: "address1",
    type: "text",
    placeholder: "Individual Address", // Changed for individual
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
  {
    label: "Address1",
    name: "address2",
    type: "text",
    placeholder: "Individual Address", // Changed for individual
    required: true,
    defaultValue: "",
    maxLength: 40,
  },
  {
    label: "State",
    name: "stateId",
    type: "select",
    placeholder: "State",
    required: true,
    defaultValue: "",
  },
  {
    label: "City",
    name: "city",
    type: "text",
    placeholder: "City",
    required: true,
    defaultValue: "",
    suggestions: true,
  },
  {
    label: "Zip",
    name: "zip",
    type: "text",
    placeholder: "Zip",
    required: true,
    defaultValue: "",
    pattern: "^[0-9]{5}(?:-[0-9]{4})?$",
    maxLength: 5,
  },
];
